interface QuizQuitModalProps {
  isOpen: boolean;
  onClose: () => void;
  onQuit: () => void;
}

export const QuizQuitModal = (
  { isOpen, onClose, onQuit }: QuizQuitModalProps,
) => {
  if (!isOpen) return null;

  return (
    <div class="modal modal-open z-50">
      <div class="modal-box max-w-sm text-center">
        <h3 class="font-bold text-lg mb-4">Leave Game?</h3>
        <p class="mb-6 opacity-60">You will be disconnected from the room.</p>
        <div class="flex gap-2 justify-center">
          <button type="button" class="btn btn-ghost" onClick={onClose}>
            Cancel
          </button>
          <button type="button" class="btn btn-error" onClick={onQuit}>
            Leave
          </button>
        </div>
      </div>
      <div class="modal-backdrop" onClick={onClose}></div>
    </div>
  );
};
